"use client";

import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { flex, stack } from "styled-system/patterns";

interface StatsSectionProps {
  usersWithPoints: string;
  pointsDistributed: string;
}

export function StatsSection({ usersWithPoints, pointsDistributed }: StatsSectionProps) {
  const t = useTranslations("points.stats");

  return (
    <div
      className={stack({
        gap: { base: "24", md: "32" },
        alignItems: "center",
        pt: { base: "40", md: "80" },
        pb: { base: "40", md: "[60px]" },
        px: { base: "16", md: "0" },
        w: "full",
      })}
    >
      <h2
        className={css({
          textStyle: { base: "heading.md", md: "heading.lg" },
          color: "text.primary",
        })}
      >
        {t("title")}
      </h2>
      <div
        className={flex({
          gap: { base: "24", md: "[100px]" },
          justify: "center",
          alignItems: { base: "center", md: "flex-start" },
          flexDirection: { base: "column", md: "row" },
          w: "full",
        })}
      >
        <StatItem label={t("usersWithPoints")} value={usersWithPoints} />
        <StatItem label={t("pointsDistributed")} value={pointsDistributed} />
      </div>
    </div>
  );
}

interface StatItemProps {
  label: string;
  value: string;
}

function StatItem({ label, value }: StatItemProps) {
  return (
    <div
      className={stack({
        alignItems: "center",
        gap: "2",
        w: { base: "full", md: "[232px]" },
        textAlign: "center",
      })}
    >
      <span
        className={css({
          textStyle: "heading.xs",
          color: "text.tertiary",
          textTransform: "uppercase",
        })}
      >
        {label}
      </span>
      <span
        className={css({
          textStyle: "subheading.xl",
          fontWeight: "light",
          color: "text.secondary",
        })}
      >
        {value}
      </span>
    </div>
  );
}
